<div class="main-holder">
  <router-outlet/>
</div>
